searchHandler = {
    $html = $('html'),
    $searchButton = $('.search-button'),
    $panelSearch = $('.panel-search'),
    $triggerClose = $('.trigger-close'),
    $triggerStartSearch = $('.trigger-start-search'),
    $textSearch = $('.text-search'),
    $resultsContainer = $('.results-container'),
    $resultsCount = $('.results-count'),
    $toolkitText = $('.toolkit-text'),

    searchData = function($query){
        var self = this;

        this.$resultsCount.text('');
        this.$resultsContainer.html('');
        
        if ($query.trim().length > 0) {
            $.ajax({
                type: 'post',
                url: myAjax.ajax_url,
                data: {
                    action: 'search_action',
                    search_query: $query,
                },
                success: function(response) {
                    self.$resultsContainer.html(response['html']);
                    var searchResultCounter =  self.$resultsContainer.find('.panel-search-result').data('search-result-counter');
                    self.$resultsCount.text('Showing '+searchResultCounter+' results');
                    self.$resultsContainer.find('.toolkit-text').each(function(){
                        var text = $(this).data('match-text');
                        $(this).html($(this).html().replace(text, '<span style="color: rgb(190, 50, 140);">'+text+'</span>'));
                    })
                }
            });
        }
    },          
    
    openClosePanelSearch = function(){
        this.$html.toggleClass('disable-scroll');
        this.$panelSearch.toggleClass('opened');
        this.clearForm();
    },

    clearForm = function(){
        this.$textSearch.val('');
        this.$resultsCount.text('');
        this.$resultsContainer.html('');
    },

    init = function(){
        var self = this;
        this.$panelSearch.removeClass('opened');

        this.$searchButton.on("click", function(e){
            e.preventDefault();
            window.scrollTo({top: 0, behavior: 'smooth'});
            self.openClosePanelSearch();
        });

        this.$triggerClose.on("click", function(){
            self.openClosePanelSearch();
        });

        this.$triggerStartSearch.on("click", function(e){
            e.preventDefault();
            self.searchData(self.$textSearch.val());    
        })

        this.$textSearch.on('change', function(){
            self.searchData($(this).val());
        })
    }
}